var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hd'),_vm._v(" "),_c('div',{staticStyle:{"margin":"180px auto 60px","width":"90%"}},[(_vm.product_id)?_c('PRODUCT',{attrs:{"productId":_vm.product_id,"merchantId":_vm.merchant_id}}):_vm._e()],1),_vm._v(" "),_c('ft',{staticClass:"ft"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5a0a012","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/products/Detail.vue
// module id = null
// module chunks = 